(function () {
  /**
   * @ngdoc module
   * @name akitabox.ui.components.reportingCharts.woActivityChart
   *
   * @param {Object} building - building to build the chart with
   */
  angular
    .module("akitabox.ui.components.reportingCharts.woActivityChart", [
      "akitabox.constants",
      "akitabox.core.lib.moment",
      "akitabox.core.services.chart",
      "akitabox.core.services.workOrder",
      "akitabox.ui.components.reportingCharts.chartLegend",
      "akitabox.ui.directives.lineChart",
    ])
    .component("abxWoActivityChart", {
      bindings: {
        buildings: "<abxBuildings",
        startDate: "<abxStartDate",
        endDate: "<abxEndDate",
        filters: "<abxFilters",
      },
      controller: AbxWoActivityChartController,
      controllerAs: "vm",
      templateUrl:
        "app/core/ui/components/reporting-charts/wo-activity-chart/wo-activity-chart.component.html",
    });
  function AbxWoActivityChartController(
    // Angular
    $q,
    $log,
    moment,
    // Constants
    models,
    // Services
    ChartService,
    ShadowService
  ) {
    var self = this;
    var config = null;
    var GA_CATEGORY = "reporting";

    // Attributes
    self.idTag = "wo-activity-chart";
    self.data = [];
    self.visibleData = [false, false, false];
    self.showChart = false;
    self.isEmpty = true;
    self.loading = true;
    self.chartColors = ["#2D8DD9", "#FFA836", "#A1C750"];
    self.lines = buildActivityLines();
    self.hoverLabels = ["Opened", "Canceled", "Completed"];

    self.toggleLineVisibility = toggleLineVisibility;

    // ------------------------
    //   Life Cycle
    // ------------------------

    self.$onInit = function () {
      if (!self.buildings || self.buildings.length === 0) {
        $log.error("abxWoActivityChart: abx-buildings is required");
        return;
      }
    };

    self.$onChanges = function (changes) {
      if (changes.buildings) {
        config = ChartService.getChartConfig(
          self.buildings,
          models.WORK_ORDER.MODEL
        );
      }
      if (changes.startDate || changes.endDate) {
        self.lines = buildActivityLines();
      }
      if (
        changes.startDate ||
        changes.endDate ||
        changes.filters ||
        changes.buildings
      ) {
        calculateStats();
      }
    };

    // ------------------------
    //   Events
    // ------------------------

    // ------------------------
    //   Public Functions
    // ------------------------

    function toggleLineVisibility(index) {
      var toggled = ChartService.toggleLineVisibility(
        index,
        self.lines,
        self.visibleData
      );
      var action =
        "toggle-line-" + (toggled.lines[index].visible ? "on" : "off");
      var name = toggled.lines[index].name;
      ShadowService.setSelectedOption(name);
      ShadowService.sendEvent(GA_CATEGORY, action, self.idTag);

      self.visibleData = toggled.visibleData;
      self.lines = toggled.lines;
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function setShowChart() {
      var options = {
        startDate: self.startDate,
        endDate: self.endDate,
      };
      self.showChart = ChartService.shouldShowChart(
        models.WORK_ORDER.MODEL,
        ChartService.CHART_TYPE_LINE,
        self.data,
        options
      );
    }

    /**
     * Calculate the workOrder stats for the given date
     */
    function calculateStats() {
      if (
        self.startDate.toString() === "Invalid Date" ||
        self.endDate.toString() === "Invalid Date"
      )
        return;
      self.loading = true;
      self.showChart = false;

      var requests = [];
      for (var i = 0; i < self.lines.length; ++i) {
        var currentLine = self.lines[i];
        var params = angular.extend(
          {},
          {
            group_time: ChartService.getGroupTime(self.startDate, self.endDate),
            // Start dates should be calculated in UTC, not local time
            timezone: currentLine.name === "Opened" ? null : moment.tz.guess(),
          },
          currentLine.params
        );
        var currentRequest = getWoStats(params, i);
        requests.push(currentRequest);
      }

      $q.all(requests).finally(function () {
        self.loading = false;
        setShowChart();
      });
    }

    function getWoStats(params, statusIndex) {
      var dates = ChartService.buildDateArray(self.startDate, self.endDate);

      params = angular.extend(params, self.filters);

      if (config.buildingInString) params.buildings = config.buildingInString;

      return config
        .statsFunction(config.parentId, params)
        .then(function (results) {
          var stats = ChartService.parseDateResults(results, dates);
          self.data[statusIndex] = stats;
          if (self.lines[statusIndex].visible) {
            self.visibleData[statusIndex] = true;
          }
        });
    }

    function buildActivityLines() {
      var dateString = ChartService.buildDateString(
        self.startDate,
        self.endDate
      );
      return [
        {
          name: "Opened",
          params: {
            group_field: "start_date",
            start_date: dateString,
          },
          visible: true,
        },
        {
          name: "Canceled",
          params: {
            group_field: "canceled_date",
            canceled_date: dateString,
          },
          visible: true,
        },
        {
          name: "Completed",
          params: {
            group_field: "completed_date",
            completed_date: dateString,
          },
          visible: true,
        },
      ];
    }
  }
})();
